import { TransformField } from './fields.model';

export class OutputModel {
  constructor(public name = '', public fields: TransformField[] = []) {}
}
